<template>
<div>
    <v-toolbar flat>
        <v-btn icon>
            <v-icon large @click="back">keyboard_arrow_left</v-icon>
        </v-btn>
   </v-toolbar>
    <gallery ref="gallery" :images="images" :index="index" @close="index = null"></gallery>
    <div class="images-drag-bar" v-dragscroll="dragEnabled" v-dragscroll:nochilddrag v-dragscroll.x="true" v-on:dragscrollmove="startdragging" v-on:dragscrollend="stopdragging">
        <div :style="{ height: '300px', width : imagesContainerWidth  }">
        <div
            v-for="(image, imageIndex) in property.photos"
            class="draggable-image"        
            :key="imageIndex"
            @click="imageClick(imageIndex)"
            :style="{ backgroundImage: 'url(' + image.path + ')' }"
        ></div>
        </div>
    </div> 
    <v-layout wrap row class="pa-4">
            <v-flex lg4 md4 xs12>
                <h1>{{ property.title }}</h1>
                <span class="money-amount">{{ formatMoney(property.price) + "€ " + (property.isForRent ? "/mes" : "") }}</span>
                <br>
                <ul class="property-data-list">
                    <li><span class="property-location"> {{ property.town.state.name + ", " + property.town.name + ", " + property.zone }}</span></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Referencia : </span></div><span class="property-location floating-right mr-3">{{ property.id }} </span></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Superficie : </span></div><span class="property-location floating-right mr-3"> {{ property.surface }} m<sup>2</sup></span></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Dormitorios : </span></div><span class="property-location floating-right mr-3"> {{ property.bedroomQuantity }}</span></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Baños : </span></div><span class="property-location floating-right mr-3"> {{ property.bathroomQuantity }}</span></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Aseos : </span></div><span class="property-location floating-right mr-3"> {{ property.cleanlinessQuantity }}</span></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Ascensor : </span></div><v-icon large class="boolean-icon floating-right mr-3" :color="property.elevator ? 'green' : 'red' "> {{ property.elevator ? "done" : "clear" }} </v-icon></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Parking : </span></div><v-icon large class="boolean-icon floating-right mr-3" :color="property.parking ? 'green' : 'red' "> {{ property.parking ? "done" : "clear" }} </v-icon></li>
                    <li class="list-item-third-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Terraza/Balcón : </span></div><v-icon large class="boolean-icon floating-right" :class="$mq === 'mobile' ? 'mr-3': ''" :color="property.balcony ? 'green' : 'red' "> {{ property.balcony ? "done" : "clear" }} </v-icon></li>
                    <li><br></li>
                    <li class="list-item-half-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Eficiencia Energetica</span></div><div class="rating floating-right" :class="energyClass" >{{ property.energeticCertificate}}</div></li><br>
                    <li class="list-item-half-width"><div class="aligned-label-container"><span class="standard-label aligned-label">Emisiones CO2</span></div><div class="rating floating-right" :class="cO2CertificateClass" >{{ property.cO2Certificate}}</div></li>
                </ul>
            </v-flex>
            <v-flex lg4 md4 xs12 class="pr-4">
                <h2 style="margin-bottom:30px;">Descripción detallada</h2>
                <p>{{ property.details }}</p>
            </v-flex>
            <v-flex lg4 md4 xs12 class="">
                <h2>Solicita mas información</h2>
            <v-form>
                <v-text-field
                v-model="email"
                    label="E-mail"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="subject"
                    label="Asunto"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="phone"
                    label="Teléfono"
                    required
                ></v-text-field>
                <v-textarea
                    solo
                    v-model="message"
                    name="input-7-4"
                    label="Cuerpo del email"
                ></v-textarea>
                <v-btn @click="sendEmail" block color="primary">Enviar</v-btn>
            </v-form>
        </v-flex>
    </v-layout>
    </div>
</template>

<script>
import { GET_PUBLIC_PROPERTY, API_URL } from '../constants'
import VueGallery from 'vue-gallery'
import axios from 'axios'

export default {
    components : {
        'gallery' : VueGallery
    },
    computed: {
        energyClass () {
            return 'c-' + this.property.energeticCertificate;
        },
        cO2CertificateClass () {
            return 'c-' + this.property.cO2Certificate;
        },
        imagesContainerWidth () {
            if (this.$mq == "mobile") {
                return `calc(${100 * this.images.length}vw + 100px)`;
            } else {
                return `calc(${300 * this.images.length}px + 100px)`;
            }
        }
    },
    data () {
        return {
            id : '',
            property : {},
            index: null,
            images: [],
            dragEnabled: true,
            isDragging: false,
            dragTimeout: null,
            email: '',
            subject: '',
            phone: '',
            message: ''
        }
    },
    async mounted () {
        this.id = this.$route.params.id;
        this.property = await this.$store.dispatch(GET_PUBLIC_PROPERTY, this.id);
        this.images = this.property.photos.map((photo) => photo.path);

        if (this.$mq !== "desktop") {
            this.dragEnabled = false;
        }

        this.subject = "Solicitar informacion sobre " + this.id;
    },
    methods: {
        imageClick : function (imageIndex) {
            if (this.$mq !== "desktop")
            {
                return;
            }

            if (this.isDragging) {
                this.isDragging = false;
            } else {
                this.index = imageIndex;
            } 
        },
        startdragging : function (event) {
            if (event.detail.deltaX > 0 || event.detail.deltaX < 0) 
            {
                clearTimeout(this.dragTimeout);
                this.isDragging = true;
            }
        },
        stopdragging : function () {
            this.dragTimeout = setTimeout(() => {
                if (this.isDragging) {
                    this.isDragging = false;
                }
            }, 500);
        },
        formatMoney : function (amount, decimalCount = 0, decimal = ",", thousands = ".") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
                console.log(e)
            }
        },
        back : function (){
            this.$router.go(-1);
        },   
        sendEmail() {
        axios.post(`${API_URL}/PublicProperties/Mail`, 
        {
            from: this.email,
            subject: this.subject,
            message: this.message,
            phone: this.phone,
            propertyId: this.id
        }).then((response) => {
        alert("Mensaje recibido nos pondremos en contacto con usted a la mayor brevedad posible");
        });
        }
    }
}
</script>

<style scoped>
.list-item-half-width {
    width: 40%;
    margin-top:20px;
    display: inline-block;
}

.list-item-third-width {
    width: 30%;
    margin-top:20px;
    display: inline-block;
}

.aligned-label-container {
    display: inline-block;
}

.c-A {
    background : #00722D;
}

.c-A:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #00722D!important;
}

.c-B {
    background: #0EA325;
}

.c-B:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #0EA325!important;
}

.c-C {
    background : #A4C400;
}

.c-C:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #A4C400!important;
}

.c-D {
    background : #F4E601;
}

.c-D:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #F4E601!important;
}

.c-E {
    background : #F5B901;
}

.c-E:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #F5B901!important;
}

.c-F {
    background : #E07203;
}

.c-F:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #E07203!important;
}

.c-G {
    background : #C42B1D;
}

.c-G:after {
    border-color: rgba(213,50,0,0)!important;
    border-left-color: #C42B1D!important;
}

.rating {
    position: relative;
    color: #FFF;
    font-size: .75rem;
    padding: 0 5px;
    margin: 0 11px 0 0;
    display: inline-block;
    line-height: 18px;
    margin-right:30px;
}



.rating:after {
    content: "";
    display: block;
    position: absolute;
    left: 100%;
    border: solid transparent;
    height: 18px;
    width: 0;
    border-width: 9px;
    top: 50%;
    margin-top: -9px;
}

@media (max-width: 530px) {

    .list-item-half-width {
        width: 100%;
        margin-top:20px;
        display: inline-block;
    }

    .list-item-third-width {
        width: 100%;
        display: inline-block;
    }

    .draggable-image {
        width: 100vw!important;
    }

    h1 {
        font-family: Roboto;
        margin-top:-0.5em;
        font-weight: normal;
        font-size: 2em!important;
        display:block;
        width: 100%;
        color: #840011;
    }

    .money-amount {
        margin-left  : 0!important;
    }

    ul {
        padding: 0;
    }
}

.property-data-list {
    margin-top:30px;
    padding: 0;
    list-style-type: none;
}

.boolean-icon{
    font-weight: bolder;
}

.images-drag-bar {
    height: 300px;
    width: 100vw;
    overflow: hidden;
    overflow-y: hidden;
}

h1 {
    font-family: Roboto;
    margin-top:-0.5em;
    font-weight: normal;
    font-size: 3em;
    color: #840011;
    display: inline-block;
}

h2 {
    font-family: Roboto;
    font-weight: lighter;
    color: #840011; 
    font-size: 3em;
}

.money-amount {
    margin-left: 1em;
    font-size: 2em;
    font-weight:300;
}

.money-amount-month {
    font-size: 1.5em;
    font-weight: lighter;
}

.back-button {
    display:block;
}

.draggable-image {
    width: 300px;
    height: 300px;
    background-size: cover;
    display: inline-block;
    cursor : pointer;
    transition: width 1s;
}

.draggable-image:hover {
    width: 400px;
    transition: width 1s;
}

.property-reference {
    font-size: 1em;
    font-weight: lighter;
}

.property-reference-label {
    font-size: 1em;
    font-weight: bold;
}

.standard-label {
    font-size: 1.25em;
    font-weight: bold;
}

.property-location {
    font-size: 1.5em;
    font-weight: lighter;
}

.floating-right {
    float: right;
}

body { 
    overflow: hidden;
}
</style>
